/**
 * Replaces all occurrences of the escaped newline sequence ('\\\n')
 * in the input string with a double space followed by a newline ('  \n').
 * This is useful for ensuring consistent formatting of line breaks.
 */
export function replaceEscapedLineBreaks(input: string): string {
  return input.replace(/\\\n/g, '  \n');
}
